var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgZoomMinus = function SvgZoomMinus(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.8 654.8c-128-128-128-336.9 0-465 128-128 336.9-128 465 0 128 128 128 336.9 0 465-128.1 128-337 128-465 0m790.1 217.8L763.6 669.5c119.3-164.8 106-397.3-42.6-545.9-164.8-164.8-432.6-164.8-597.4 0s-164.8 432.6 0 597.4c148.6 148.6 381.1 161.9 545.9 42.6l217.8 203.1c26.5 26.5 67.7 26.5 94.1 0 25-26.5 25-67.6-1.5-94.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M472.3 473.7H590c26.5 0 50-22.1 50-50-1.4-27.9-23.5-50-50-50H472.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496.2 373.7H254.6c-26.5 0-50 22.1-50 50 0 26.5 22.1 50 50 50h238"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgZoomMinus);
export default ForwardRef;